import { EuiSpacer } from '@elastic/eui';
import VideoCard from "../../../../src/components/Quick_Installation/Videos/video-domain-name-macOS";
import * as React from 'react';
export default {
  EuiSpacer,
  VideoCard,
  React
};